'use client';

import type { CSSProperties, FC, PropsWithChildren } from 'react';
import { cx } from '../../utils/cx';
import { typography } from '../../themes/DefaultTheme';
import type { SpacingTypographyProps } from './utils/spacingTypographyHelper';
import type { TypographyProps } from './utils/typographyHelper';
import { typographyStyle } from './utils/typographyHelper';
import styles from './typography.module.css';

export interface CaptionProps extends TypographyProps, SpacingTypographyProps {
  className?: string;
  display?: 'block' | 'inline';
  size?: 'S' | 'M' | 'L' | 'XL';
}

export const Caption: FC<PropsWithChildren<CaptionProps>> = ({
  size = 'M',
  display = 'block',
  className,
  children,
  ...props
}) => {
  const token: CSSProperties = {
    ...typography.caption.default,
    ...typography.caption[size as 'M'],
  };
  const style: CSSProperties = {
    ...typographyStyle(token, props),
    color: 'currentColor',
    display,
  };
  return (
    <span className={cx(styles.text, className)} style={style}>
      {children}
    </span>
  );
};
